import React, { useEffect } from 'react';
import { Outlet, useSearchParams } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from 'store/hook';
import { handleSetSelectedCommunity, handleSetSelectedParentCommunity } from 'store/slices/globalSlice';
import { getCommunitiesByIds, getCommunityById } from 'utils/helpers/communityMap';

import { RecommendationsProvider } from './RecommendationsContext';

const RecommendationsRoot = () => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const communityIdParam = searchParams.get('communityId');
  const { selectedCommunity, communityMap } = useAppSelector((state) => state.global);

  useEffect(() => {
    const communityId = communityIdParam ? Number(communityIdParam) : null;

    if (!communityId) {
      return;
    }

    if (selectedCommunity?.id === communityId) return;

    const community = getCommunityById(communityMap, communityId);
    if (!community) return;

    const nextCommunity = {
      id: community.id,
      name: community.comunity_name,
      type: community.company_relation_type,
      address: community.address,
      unit_system: community.unit_system,
      company: {
        id: community.company_id,
        name: community.company_name,
      },
      parentCommunities: getCommunitiesByIds(communityMap, community.communities),
    };

    dispatch(handleSetSelectedCommunity(nextCommunity));
    dispatch(handleSetSelectedParentCommunity(nextCommunity.parentCommunities[0] || null));
  }, [communityIdParam, communityMap, dispatch, selectedCommunity]);

  return (
    <RecommendationsProvider>
      <Outlet />
    </RecommendationsProvider>
  );
};

export default RecommendationsRoot;
